<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left>
      <vdr-language-selector
        [availableLanguageCodes]="availableLanguages$ | async"
        [currentLanguageCode]="contentLanguage$ | async"
        (languageCodeChange)="setLanguage($event)"
      ></vdr-language-selector>
    </vdr-ab-left>
    <vdr-ab-right>
      <vdr-action-bar-items
        locationId="default-product-description-translation-list"
      ></vdr-action-bar-items>
      <!-- <a
        class="button primary mr-1"
        [routerLink]="['./create']"
        *vdrIfPermissions="[
          'CreateDefaultProductDescription',
          'CreateProductdescriptionTranslation'
        ]"
      > -->
      <button
        class="button primary mr-1"
        (click)="create()"
        *vdrIfPermissions="[
          'CreateDefaultProductDescription',
          'CreateProductdescriptionTranslation'
        ]"
      >
        <clr-icon shape="plus"></clr-icon>
        {{ "common.create" | translate }}
      </button>
      <vdr-action-bar-dropdown-menu
        locationId="default-product-description-translation-list"
      >
      </vdr-action-bar-dropdown-menu>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>
<vdr-data-table-2
  class="mt-2"
  id="default-product-description-translation-list"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="default-product-description-translation-list"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  ></vdr-bulk-action-menu>
  <vdr-dt2-search
    [searchTermControl]="searchTermControl"
    [searchTermPlaceholder]="'Search by Title'"
  />
  <vdr-dt2-column
    [heading]="'common.id' | translate"
    id="id"
    [hiddenByDefault]="true"
    [sort]="sorts.get('id')"
  >
    <ng-template let-description="item">
      {{ description.id }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'common.created-at' | translate"
    id="created-at"
    [hiddenByDefault]="true"
    [sort]="sorts.get('createdAt')"
  >
    <ng-template let-description="item">
      {{ description.createdAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'common.updated-at' | translate"
    id="updated-at"
    [hiddenByDefault]="true"
    [sort]="sorts.get('updatedAt')"
  >
    <ng-template let-description="item">
      {{ description.updatedAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'Language'"
    id="title"
    [optional]="false"
  >
    <ng-template let-description="item">
      {{ description.languageCode }}
    </ng-template>
    <!-- <ng-template let-description="item">
      <a class="button-ghost" [routerLink]="['./', description.id]"
        ><span>{{ description.title }}</span
        ><clr-icon shape="arrow right"
      /></a>
    </ng-template> -->
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.title' | translate"
    id="title"
    [optional]="false"
    [sort]="sorts.get('title')"
  >
    <ng-template let-description="item">
      <a class="button-ghost" [routerLink]="['/extensions/mandatory-product-notice-translations', description.id]"
        ><span>{{ description.title }}</span
        ><clr-icon shape="arrow right"
      /></a>
    </ng-template>
  </vdr-dt2-column>
  <!-- <vdr-dt2-custom-field-column
    *ngFor="let customField of customFields"
    [customField]="customField"
    [sorts]="sorts"
  /> -->
</vdr-data-table-2>
